<template>
  <d-page-layout
    @submitSearch="handleSubmitSearch"
    @clearSearch="handleClearSearch"
    :searchParamsCount="searchParamsCount"
  >
    <template slot="heading">
      <v-breadcrumbs class="pa-0" :items="items"></v-breadcrumbs>
    </template>
    <template slot="search">
      <Search v-model="searchParams"></Search>
    </template>
    <template slot="content">
      <List :searchParams="searchParams"></List>
    </template>
  </d-page-layout>
</template>
<script>
import Search from "./Search.vue";
import List from "./List.vue";

const initialSearchParams = {
  userId: null,
  logTypeCode: null,
  actionTypeCode: null,
  fromDate: null,
  toDate: null,
};

export default {
  components: {
    Search,
    List,
  },
  data: (vm) => ({
    items: [
      {
        text: vm.$t("logs.page-heading"),
        disabled: true,
      },
    ],
    searchParams: { ...initialSearchParams },
    searchParamsCount: 0,
  }),
  methods: {
    handleSubmitSearch() {
      this.searchParamsCount = this.getChangedFormItemsCount(
        this.searchParams,
        initialSearchParams
      );
      this.$eventBus.$emit("fetchLogs");
    },
    handleClearSearch() {
      this.searchParams = { ...initialSearchParams };
      this.handleSubmitSearch();
    },
  },
  async mounted() {
    this.$eventBus.$emit("fetchLogs");
  },
};
</script>
